<template>
  <v-container 
    v-if="!$apollo.loading"
    fill-height
    fluid
    grid-list-xl
  >
    <v-layout
      justify-center
      wrap
    >
      <v-flex
        v-if="!_.isEmpty(invoices)"
        md12
      >
        <h2>{{ $t('invoices.invoices') }}</h2>
        <v-card>
          <v-data-table
            class="text-no-wrap" 
            :headers="headers"
            :items="invoices"
            :hide-default-footer="true"
            :mobile-breakpoint="900"
            :items-per-page="200"
          >
            <template
              slot="headerCell"
              slot-scope="{ header }"
            >
              <span
                v-text="header.text"
              />
            </template>
            <template v-slot:item.id="{ item }">
              <router-link :to="`/myinvoice/${item.id}`">
                <b>{{ item.id }}</b>
              </router-link>
            </template>
            <template v-slot:item.created_at="{ item }">
              {{ item.created_at | moment('ll') }}
            </template>
            <template v-slot:item.total="{ item }">
              <b>{{ item.total }} {{ item.currency }}</b>
            </template>
            <template v-slot:item.status="{ item }">
              <b 
                :class="colorStatus(item.status)"
              >
                {{ $t('invoices.'+item.status) }} 
              </b>
              <small v-if="item.status == 'unpaid'"><br>
                {{ $t('invoices.due') }}:<b> {{ item.due_date | moment('L') }}</b>
              </small>
            </template>
           
            <template v-slot:item.actions="{ item }">
              <v-btn
                outlined
                text
                small
                @click="$router.push(`/myinvoice/${item.id}`)"
              >
                {{ $t('invoices.viewButton') }}
              </v-btn>  
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
      <v-flex
        v-else
        md5
        xs12
        new-record
      >
        <v-row>
          <v-col cols="12">
            <v-row
              justify="center"
              align="center"
            >
              <v-col>
                <v-card
                  style="padding:50px"
                >
                  <component
                    :is="newIcon"
                    style="margin-bottom:20px;"
                  />
                  <h3>{{ $t('invoices.myInvoices') }}</h3>
                  <p>{{ $t('invoices.notFoundDesc') }}</p>
                </v-card> 
              </v-col>
            </v-row>  
          </v-col>
        </v-row>    
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>

const INVOICES_QUERY = require('@/graphql/queries/Invoices.gql');
import IconInvoice from '@/components/icons/IconInvoice.vue'


export default {
  name: 'Invoices',
  data() {
    return {
      newIcon: IconInvoice,
      loading: false,
      invoices: [],
      selectedItem: {
        id: null
      },
      headers: [
        {
          sortable: false,
          text: this.$t('invoices.invoice'),
          value: 'id'
        },
        {
          sortable: false,
          text: this.$t('invoices.created'),
          value: 'created_at',
        },
        {
          sortable: false,
          text: this.$t('invoices.sum'),
          value: 'total'
        },
        {
          sortable: false,
          text: this.$t('invoices.status'),
          value: 'status'
        },
        {
          sortable: false,
          text: '',
          value: 'actions',
        },
      ]
    }
  },
  methods: {
  },
  apollo: {
    invoices: {
      query: INVOICES_QUERY,
    }
  }
}
</script>
<style lang="scss" scoped>
 
</style>
